import { render, staticRenderFns } from "./BossAverage.vue?vue&type=template&id=405ce924&scoped=true&"
import script from "./BossAverage.vue?vue&type=script&lang=js&"
export * from "./BossAverage.vue?vue&type=script&lang=js&"
import style0 from "./BossAverage.vue?vue&type=style&index=0&id=405ce924&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405ce924",
  null
  
)

export default component.exports